import { render, staticRenderFns } from "./LianderBundle.vue?vue&type=template&id=36d61cfa"
import script from "./LianderBundle.vue?vue&type=script&lang=js"
export * from "./LianderBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports